import { useSelector } from 'react-redux'
import { useCookies } from 'react-cookie'
import _ from 'lodash'
import { getRouter } from '../reducers'
import { useEffect } from 'react'

const excludedRoutes = [
  "/login"
]

export default function LastLocationCookie() {
  const cookieName = "last_route"
  const [cookies, setCookie] = useCookies([cookieName])
  const lastLocation = _.get(useSelector(getRouter), "location.pathname")

  useEffect(() => {
    if (lastLocation && !_.includes(excludedRoutes, lastLocation)) {
      setCookie(cookieName, lastLocation, { path: "/" })
    }
  }, [lastLocation, setCookie])

  return null
}
